import { useQuery } from "@apollo/client"
import { Chip } from "@heroui/react"
import { ErrorPlaceholder, LoadingPlaceholder, SimplePlaceholder } from "@components"
import { CircleStackIcon } from "@heroicons/react/24/outline"
import { GET_GUARDIAN_STUDENTS } from "@graphql"
import { studentFullname } from "@helpers"
import PropTypes from "prop-types"

const GuardianStudentsList = ({ guardian }) => {
  const { loading, error, data } = useQuery(GET_GUARDIAN_STUDENTS, {
    variables: {
      fetchPolicy: "cache-first",
      id: guardian.id,
    },
  })

  if (loading) return <LoadingPlaceholder caption="Loading students..." icon={CircleStackIcon} />

  if (error) return <ErrorPlaceholder caption="There was an error loading the students for this guardian." error={error} />

  if (data?.guardian?.students?.length === 0) {
    return (
      <SimplePlaceholder icon={CircleStackIcon} isFullHeight={false} title="No students found for this guardian">
        <p className="mt-1 text-content2-foreground">
          If you believe this guardian should have associated students then please check your MIS and Xporter
          integration.
        </p>
      </SimplePlaceholder>
    )
  }

  return (
    <ul className="divide-y divide-gray-300 dark:divide-content2-foreground divide-dotted">
      {data?.guardian?.students?.map(student => (
        <li key={student.id} className="flex justify-between py-3">
          {studentFullname(student)} {student.intake && <Chip color="primary">Year {student.intake}</Chip>}
        </li>
      ))}
    </ul>
  )
}

GuardianStudentsList.propTypes = {
  guardian: PropTypes.object.isRequired,
}

export default GuardianStudentsList
